import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC019_Request,
  IAPI_FAC019_Response,
  IAPI_PRE010_Request,
  IAPI_PRE010_Response,
} from "../../../type/apiType";

// プルダウン用有効施設一覧参照
const httpAPI_FAC019 = async (
  param: IAPI_FAC019_Request
): Promise<IAPI_FAC019_Response> => {
  let res = await http.post(ApiUrl.API_FAC019, {
    ...param,
  });

  return res.data;
};

// 掛金納付対象職員届の提出確認参照
const httpAPI_PRE010 = async (
  param: IAPI_PRE010_Request
): Promise<IAPI_PRE010_Response> => {
  let res = await http.post(ApiUrl.API_PRE010, {
    ...param,
  });
  return res.data;
};

export { httpAPI_FAC019, httpAPI_PRE010 };
